import React, { useRef } from 'react';
import { FaArrowLeft, FaChalkboardTeacher, FaPhone, FaStopwatch, FaVideo } from 'react-icons/fa';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Toast } from 'primereact/toast';
import NewInterviewSessionForm from '../features/session/forms/NewInterviewSessionForm';
import TimedPitchSessionForm from '../features/session/forms/TimedPitchSessionForm';
import NewWhiteBoardSessionForm from '../features/session/forms/NewWhiteBoardSessionForm';
import { analytics } from '../features/firebase/firebase-config';

export enum INTERVIEW_TYPES {
    VIDEO_INTERVIEW = 'video-interview',
    PHONE_INTERVIEW = 'phone-interview',
    WHITEBOARD_SESSION = 'whiteboard-session',
    PUBLIC_SPEAKING_SESSION = 'public-speaking',
    TIMED_PITCH_SESSION = 'timed-pitch',
}

const NewSession: React.FC = () => {
    analytics.logEvent('page_view', {
        page_title: 'new session',
    });
    const navigate = useNavigate();
    const toast = useRef<Toast>(null);
    const [searchParams] = useSearchParams();
    const type = searchParams.get("type");

    const FormViwerSwitch = ({ type }: { type: string }) => {
        switch (type) {
            case INTERVIEW_TYPES.VIDEO_INTERVIEW:
                {
                    const icon = <FaVideo className="text-blue-500 text-6xl mx-auto mb-4" />
                    return <NewInterviewSessionForm icon={icon} type={type} />
                }
            case INTERVIEW_TYPES.PHONE_INTERVIEW:
                {
                    const icon = <FaPhone className="text-blue-500 text-6xl mx-auto mb-4" />
                    return <NewInterviewSessionForm icon={icon} type={type} />
                }
            case INTERVIEW_TYPES.TIMED_PITCH_SESSION:
                {
                    const icon = <FaStopwatch className="text-blue-500 text-6xl mx-auto mb-4" />
                    return <TimedPitchSessionForm icon={icon} type={type} />
                }
            case INTERVIEW_TYPES.WHITEBOARD_SESSION:
                {
                    const icon = <FaChalkboardTeacher className="text-blue-500 text-6xl mx-auto mb-4" />
                    return <NewWhiteBoardSessionForm icon={icon} type={type} />
                }
            default:
                return
        }
    }

    return (
        <div className="min-h-screen flex flex-col">
            <Toast ref={toast} />
            <header className="flex justify-between items-center p-6">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center text-gray-800 hover:text-gray-200 transition"
                >
                    <FaArrowLeft className="mr-2" />
                    Back
                </button>
            </header>
            <div className='bg-gradient-to-r from-blue-100 to-purple-100'>
                {
                    type && <FormViwerSwitch type={type} />
                }
            </div>
        </div>
    );
};

export default NewSession;
